import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import { ConfigNamesEnum } from './storeTypes';

import rootReducer from '../reducers';
import { errorLoggerMiddleware } from './middleware/errorLogger';
import config from '../config/config';

const DEV_ENVS: string[] = [ConfigNamesEnum.Dev, ConfigNamesEnum.Auto];
const isDev = DEV_ENVS.includes(config.ENV_NAME);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const devToolsCompose = isDev && (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
const composeEnhancers: typeof compose = devToolsCompose
  ? devToolsCompose({ name: 'Konnect Client', trace: true, traceLimit: 25 })
  : compose;

const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(thunk, errorLoggerMiddleware))
);

export default store;
